export default "__VITE_ASSET__DUIr5Ha1__"